import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultStatisticsCard from "examples/Cards/StatisticsCards/DefaultStatisticsCard";
import DataTable from "examples/Tables/DataTable";

import api from "services/api";
import { requireAuth } from "actions/AuthAction";

const statusLabel = {
  DIAJUKAN: "Baru",
  VERIFIKASI: "Diverifikasi",
  PERBAIKAN: "Perbaikan",
  PROSES_TEKNIS: "Teknis",
  DISETUJUI: "Disetujui",
  DITOLAK: "Ditolak",
  PENANDATANGANAN: "TTD",
  SELESAI: "Selesai",
};

function DashboardPetugas() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [antrian, setAntrian] = useState([]);

  useEffect(() => {
    const user = requireAuth(navigate, ["PETUGAS", "VERIFIKATOR", "PIMPINAN", "ADMIN", "SUPER_ADMIN"]);
    if (!user) return;

    api
      .get("verifikasi/pengajuan")
      .then((res) => setAntrian(res.data?.data || []))
      .catch(() => alert("Gagal memuat antrian verifikasi"))
      .finally(() => setLoading(false));
  }, [navigate]);

  const stats = {
    baru: antrian.filter((p) => p.status === "DIAJUKAN").length,
    verifikasi: antrian.filter((p) => p.status === "VERIFIKASI").length,
    perbaikan: antrian.filter((p) => p.status === "PERBAIKAN").length,
    teknis: antrian.filter((p) => p.status === "PROSES_TEKNIS").length,
  };

  const columns = [
    { Header: "Nomor", accessor: "nomor", width: "18%" },
    { Header: "Pemohon", accessor: "pemohon", width: "22%" },
    { Header: "Layanan", accessor: "layanan", width: "30%" },
    { Header: "Status", accessor: "status", width: "15%" },
    { Header: "Aksi", accessor: "action", align: "center" },
  ];

  const rows = antrian.map((p) => ({
    nomor: p.nomor_pengajuan,
    pemohon: p.nama_pemohon,
    layanan: p.nama_jenis_izin,
    status: statusLabel[p.status] || p.status,
    action: (
      <MDButton
        size="small"
        color="info"
        variant="text"
        onClick={() => navigate(`/pengajuan/${p.id}`)}
      >
        Proses
      </MDButton>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <MDTypography variant="h4" fontWeight="medium">
            Dashboard Petugas
          </MDTypography>
          <MDTypography variant="button" color="text">
            Antrian pelayanan perizinan DPMPTSP
          </MDTypography>
        </MDBox>

        <Grid container spacing={3} mb={3}>
          <Grid item xs={12} md={3}>
            <DefaultStatisticsCard title="Pengajuan Baru" count={loading ? "..." : stats.baru} icon={{ color: "info", component: "inbox" }} />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultStatisticsCard title="Diverifikasi" count={loading ? "..." : stats.verifikasi} icon={{ color: "warning", component: "fact_check" }} />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultStatisticsCard title="Perbaikan" count={loading ? "..." : stats.perbaikan} icon={{ color: "error", component: "build" }} />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultStatisticsCard title="Proses Teknis" count={loading ? "..." : stats.teknis} icon={{ color: "dark", component: "engineering" }} />
          </Grid>
        </Grid>

        <Card>
          <MDBox p={3}>
            <MDTypography variant="h6" mb={2}>
              Antrian Verifikasi
            </MDTypography>
            <DataTable table={{ columns, rows }} entriesPerPage={{ defaultValue: 10 }} canSearch />
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardPetugas;
